const locale = {
	HELP_CENTER: 'Помощен Център',
	HELP_CENTER_TITLE: 'Как можем да помогнем днес?',
	HELP_CENTER_DESCRIPTION: 'Ние сме тук, за да ви помогнем с всякакви въпроси или проблеми, които можете да имате. Моля, използвайте полето за търсене, за да намерите информацията, която ви е необходима.',
	HELP_CENTER_SEARCH: 'Търсене',
	HELP_CENTER_SEARCH_PLACEHOLDER: 'Търсене',
	HELP_CENTER_SEARCH_RESULTS: 'Резултати от търсенето',
	HELP_CENTER_SEARCH_NO_RESULTS: 'Няма намерени резултати',
	HELP_CENTER_SEARCH_NO_RESULTS_DESCRIPTION: 'Моля, опитайте отново с различни ключови думи.',
	FAQs: 'ЧЗВ',
	FAQs_DESCRIPTION: 'Често задавани въпроси и отговори',
	GO_TO_FAQs: 'Към ЧЗВ',
	GUIDES: 'Ръководство',
	GUIDES_DESCRIPTION: 'Статии и ресурси, които да ви насочат',
	GO_TO_GUIDES: 'Към Ръководство',
	SUPPORT: 'Поддръжка',
	SUPPORT_DESCRIPTION: 'Свържете се с нас',
	GO_TO_SUPPORT: 'Към Поддръжката',
	MOST_FREQUENTLY_ASKED_QUESTIONS: 'Често задавани въпроси',
	MOST_FREQUENTLY_ASKED_QUESTIONS_DESCRIPTION: 'Ето най-често задаваните въпроси, които можете да проверите преди да започнете',
	
	// Guide Categories
	GUIDES_AND_RESOURCES: 'Ръководство',
	GETTING_STARTED: 'Системни Настройки',
	GETTING_STARTED_DESCRIPTION: 'Основни упътвания, които да ви помогнат да започнете да използвате нашата платформа',
	ACCOUNT_MANAGEMENT: 'Управление на Акаунт',
	ACCOUNT_MANAGEMENT_DESCRIPTION: 'Управлявайте настройките на акаунта си',
	CLEANING_MANAGEMENT: 'Управление на Почистване',
	CLEANING_MANAGEMENT_DESCRIPTION: 'Научете как работи почистването на стаите',
	CLEANING_OPERATIONS: 'Страница Почистване (Главен Камериер и Администратор)',
	CLEANING_OPERATIONS_DESCRIPTION: 'Научете как се извършва почистването на стаите',
	CLEANING_OPERATIONS_SUBTITLE: '',
	CLEANING_SESSIONS: 'История на почистванията',
	CLEANING_SESSIONS_DESCRIPTION: 'Научете как да проверявате историята на почистванията',
	CLEANING_SESSIONS_SUBTITLE: '',
	CLEANING_PAGE_CLEANER: 'Страница Почистване (Камериер)',
	CLEANING_PAGE_CLEANER_SUBTITLE: 'Научете как да извършите Почистване',
	CLEANER_SUBMIT_PROBLEM: 'Страница Почистване: Докладване на проблем',
	CLEANER_SUBMIT_PROBLEM_SUBTITLE: '',
	TECHNICAL_SUPPORT: 'Техническа поддръжка',
	TECHNICAL_SUPPORT_DASHBOARD: 'Страница Техническа поддръжка',
	TECHNICAL_SUPPORT_DESCRIPTION: 'Научете как да използвате заявките за поддръжка',
	TECHNICAL_SUPPORT_SUBTITLE: '',
	FEATURES_AND_TOOLS: 'Функционалности',
	FEATURES_AND_TOOLS_DESCRIPTION: 'Научете за наличните функционалности на платформата',
	TROUBLESHOOTING: 'Отстраняване на Проблеми',
	TROUBLESHOOTING_DESCRIPTION: 'Често срещани проблеми и техните решения',
	
	// Articles
	WELCOME_TO_OUR_PLATFORM: 'Хотелски Настройки',
	WELCOME_TO_OUR_PLATFORM_SUBTITLE: 'Първи стъпки за започване на работа с нашата платформа',
    TEAM_MANAGEMENT: 'Управление на Екип',
    TEAM_MANAGEMENT_SUBTITLE: 'Научете как да управлявате екипа си',
	PASSWORD_SECURITY_BEST_PRACTICES: 'Най-добри Практики за Сигурност на Пароли',
	PASSWORD_SECURITY_BEST_PRACTICES_SUBTITLE: 'Научете как да създавате и поддържате сигурни пароли',
	ADVANCED_SEARCH_TECHNIQUES: 'Разширени Техники за Търсене',
	ADVANCED_SEARCH_TECHNIQUES_SUBTITLE: 'Овладейте функционалността за търсене, за да намерите точно това, което ви трябва',
	COMMON_LOGIN_ISSUES: 'Често Срещани Проблеми при Влизане и Решения',
	COMMON_LOGIN_ISSUES_SUBTITLE: 'Отстраняване на най-често срещаните проблеми при влизане',
	OVERVIEW: 'Обобщен преглед на дневната дейност',
	OVERVIEW_SUBTITLE: 'Каква информация можете да намерите в дневния преглед?', 
	DAILY_ASSIGNMENTS_LIST: 'Списък със задачите на всеки камериер за деня',
	DAILY_ASSIGNMENTS_LIST_SUBTITLE: '',
	ROOMIE_AI_INTELLIGENT_ASSISTANT: 'Roomie AI Интелигентен Асистент',
	ROOMIE_AI_INTELLIGENT_ASSISTANT_SUBTITLE: 'Научете как да използвате Roomie AI Интелигентен Асистент',
	
	// Article Content
	WELCOME_CONTENT: `
		<h3>Какво Ще Научите</h3>
		<ul>
			<li>Как да създадете етажи</li>
			<li>Как да създадете стаи</li>
			<li>Как да създадете списъци за почистване</li>
			<li>Как да създадете списъци за поддръжка</li>
		</ul>

		<h3><b style="color: red;">Важно!</b> Само потребителите с роля Администратор могат да създават етажи, стаи, списъци за почистване и елементи за поддръжка.</h3>
		
        <h3>Как да създадем етаж</h3>
        <img src="/assets/images/help-center/hotel-settings-floors-bg.png" style="border: 1px solid #ccc" />
		
		<h4>Стъпка 1: Попълване на полета</h4>
		<p>Попълнете полето "Име на етаж" и полето "Номер на етаж".</p>
		
		<h4>Стъпка 2: Натиснете бутона "Създаване на етаж"</h4>
		<p>Етажът ще бъде създаден и ще се появи в списъка с етажи.</p>
        <hr style="border: 1px solid #ccc" />
        <h3>Как да създадем стая</h3>
        <img src="/assets/images/help-center/hotel-settings-rooms-bg.png" style="border: 1px solid #ccc" />
		
		<h4>Стъпка 1: Попълване на полета</h4>
		<p>Попълнете полето "Име", полето "Брой легла", полето "Етаж" и полето "Тип стая".</p>
		
		<h4>Стъпка 2: Натиснете бутона "Създаване на стая"</h4>
		<p>Стаята ще бъде създадена и ще се появи в списъка със стаи.</p>
        <hr style="border: 1px solid #ccc" />
        <h3>Как да създадем списък за почистване</h3>
        <img src="/assets/images/help-center/hotel-settings-cleaning-checklist-bg.png" style="border: 1px solid #ccc" />

        <h4>Стъпка 1: Натиснете бутона "Създай списък"</h4>
		<p>Ще се появи прозорец за създаване на списък за почистване.</p>
        <img src="/assets/images/help-center/hotel-settings-checklist-creation-bg.png" style="border: 1px solid #ccc" />
		
		<h4>Стъпка 2: Попълване на задължителните полета на списъка</h4>
		<p>Попълнете полето "Име на списък"</p>

        <h4>Стъпка 3: Попълване на задължителните полета на задачата</h4>
		<p>Попълнете полето "Заглавие на задачата", полето "Категория (Спалня, Баня или и двете)" и маркирайте кутийката дали задача е задължителна.</p>
		
        <h4>Стъпка 4: Натиснете бутона "Добави задача"</h4>
		<p>Задачата ще бъде добавена към списъка за почистване. Може да добавите повече задачи, като повторите стъпки 3 и 4.</p>

		<h4>Стъпка 5: Натиснете бутона "Създаване на списък"</h4>
		<p>Списъкът ще бъде създаден с добавените задачи и ще се появи при другите списъци за почистване.</p>

        <hr style="border: 1px solid #ccc" />
        <h3>Как да създадем елемент за поддръжка</h3>
        <img src="/assets/images/help-center/hotel-settings-maintenance-items-bg.png" style="border: 1px solid #ccc" />

        <h4>Стъпка 1: Натиснете бутона "Създай елемент за поддръжка"</h4>
		<p>Ще се появи прозорец за създаване на елемент за поддръжка.</p>
        <img src="/assets/images/help-center/hotel-settings-maintenance-item-creation-bg.png" style="border: 1px solid #ccc" />

        <h4>Стъпка 2: Попълване на задължителните полета на елемента за поддръжка</h4>
		<p>Изберете "Категория", маркирайте дали елемента е активен от кутийката "Активен елемент" и попълнете полето "Име на елемента" минимум на български език.</p>

        <h4>Стъпка 3: Натиснете бутона "Създай"</h4>
		<p>Елементът за поддръжка ще бъде създаден и ще се появи в списъка със елементи за поддръжка. Може да добавите повече елементи, като повторите стъпка 2 и 3.</p>
        
	`,

    TEAM_MANAGEMENT_CONTENT: `
        <h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да управлявате екипа</li>
            <li>Как да добавите членове в екипа</li>  
        </ul>
		<h3><b style="color: red;">Важно!</b> Само потребители с роля Администратор могат да канят членове към екипа.</h3>
        <h3>Как да управлявате екипа</h3>
        <img src="/assets/images/help-center/hotel-settings-users-management-bg.png" style="border: 1px solid #ccc" />
        <p>На тази страница можете да управлявате екипа си. <br/> Можете да добавяте членове в екипа, да променяте ролята на членовете от падащите менюта и да активирате/деактивирате техните акаунти.</p>
        <hr style="border: 1px solid #ccc" />
        <h3>Как да поканите потребител в екипа</h3>
        <h4>Стъпка 1: Натиснете бутона "Поканете потребител"</h4>
        <p>Ще се появи прозорец за покана на потребител.</p>
        <img src="/assets/images/help-center/hotel-settings-users-inviting-bg.png" style="border: 1px solid #ccc" />
        <h4>Стъпка 2: Попълване на полета</h4>
        <p>Попълнете полето "Имейл" и изберете ролята на потребителя.</p>
        <h4>Стъпка 3: Натиснете бутона "Покани"</h4>
        <p>Потребителят ще бъде поканен и ще се появи в списъка с членове на екипа. Можете да поканите повече членове, като повторите стъпки 1,2 и 3.</p>
    `,

    PROFILE_SETUP_GUIDE_CONTENT: `
        <h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да настроите профила си</li>
            <li>Как да промените паролата си</li>
        </ul>
        <h3>Как да настроите профила си</h3>
        <img src="/assets/images/help-center/account-settings-bg.png" style="border: 1px solid #ccc" />
        <p>На тази страница можете да промените вашето Име, Фамилия, Имейл и Телефон. След промяната на което и да е поле, натиснете бутона "Запази".</p>
        <hr style="border: 1px solid #ccc" />
        <h3>Как да промените паролата си</h3>
        <img src="/assets/images/help-center/account-settings-password-reset-bg.png" style="border: 1px solid #ccc" />
        <p>Натиснете бутона "Промени парола" за да промените паролата си.</p>
        <h4>Стъпка 1: Попълване на полета</h4>
        <p>Попълнете полето "Стара парола" и полето "Нова парола".</p>
        <h4>Стъпка 2: Натиснете бутона "Запази"</h4>
        <p>Паролата ще бъде променена и системата ще ви накара да влезете отново в акаунта си с новата парола.</p>
    `,

    ASSIGNMENTS_MANAGEMENT_CONTENT: `
        <h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да задавате задачи на вашият Екип</li>
            <li>Как да преназначавате задачи от един член на екипа на друг</li>
            <li>Как да отменяте задачи</li>
        </ul>
		<h3><b style="color: red;">Важно!</b> Само потребителите с роля Администратор, Рецепция или Главен Камериер могат да задават/преназначават/отменят задачи на членовете на екипа.</h3>
        <img src="/assets/images/help-center/roomie-ai-bg.png" style="border: 1px solid #ccc" />
        <hr style="border: 1px solid #ccc" />
        <h3>Как да задавате задача на вашият Екип</h3>
        <h4>Стъпка 1:</h4>
		<h4><b style="color: red;">Важно!</b> Наличните стаи трябва да са зададени предварително от ‘Хотелски настройки’.</h4>
        <ul>
            <li>Маркирайте стая или няколко стаи като кликвате върху тях</li>
            <li>Маркирайте цял етаж от бутона (Избери целия етаж)</li>
        </ul>
        <p>След маркиране, над всички етажи ще се появи секция с активен бутон "Назначи към камериер", кликнете върху него.</p>
        <h4>Стъпка 2: Натиснете бутона "Назначи към камериер"</h4>
        <img src="/assets/images/help-center/roomie-ai-assignment-section-bg.png" style="border: 1px solid #ccc" />
        <p>Ще се появи прозорец за назначаване на задача към камериер.</p>
        <h4>Стъпка 3: Изберете камериер и приоритет от падащите менюта</h4>
        <img src="/assets/images/help-center/roomie-ai-assignment-bg.png" style="border: 1px solid #ccc" />
        <h4>Стъпка 4: Натиснете бутона "Назначи"</h4>
        <p>Задачата ще бъде назначена и ще се появи в списъка за Почистване на конкретния камериер. Можете да продължите с назначаването на още задачи на други камериери, като повторите стъпки 1, 2, 3 и 4.</p>
        <hr style="border: 1px solid #ccc" />
		<h3>Как да преназначавате задача от един член на екипа на друг</h3>
		<img src="/assets/images/help-center/roomie-ai-reassignment-bg.png" style="border: 1px solid #ccc" />
		<h4>Стъпка 1: Изберете вече назначена стая или стаи и кликнете върху бутона "Преназначаване"</h4>
		<p>Ще се появи прозорец за преназначаване на задача.</p>
		<img src="/assets/images/help-center/roomie-ai-reassignment-dialog-bg.png" style="border: 1px solid #ccc" />
		<h4>Стъпка 2: Изберете камериер от падащото меню и напишете причина за преназначаването</h4>
		<h4>Стъпка 3: Натиснете бутона "Преназначи всички"</h4>
		<p>Стаята или стаите ще бъдат преназначени и ще се появят в списъка за Почистване на новия камериер. Можете да продължите с преназначаването на още задачи, като повторите стъпки 1, 2 и 3.</p>
		<hr style="border: 1px solid #ccc" />
		<h3>Как да отменяте задачи</h3>
		<img src="/assets/images/help-center/roomie-ai-cancel-assignment-bg.png" style="border: 1px solid #ccc" />
		<h4>Стъпка 1: Изберете вече назначена стая или стаи и кликнете върху бутона "Отмяна на назначения"</h4>
		<p>Стаята или стаите ще бъдат отменени от съответния камериер. Можете да продължите с отмяната на още задачи, като повторите стъпка 1.</p>
    `,

	CLEANING_SESSIONS_CONTENT: `
		<h4>На страницата "История на почистванията" можете да видите историята на всички почиствания, които са се провеждали в хотела заедно с цялата информация за тях.</h4>
		<h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да проверявате историята на почистванията</li>
        </ul>
		<h3>Как да проверявате историята на почистванията</h3>
		<h4>Стъпка 1: Кликнете върху бутона "История на почистванията" които се намира в менюто в лявата част на системата</h4>
		<p>Ще ви се отвори страница с историята на почистванията.</p>
		<img src="/assets/images/help-center/cleaning-sessions-bg.png" style="border: 1px solid #ccc" />
		<h4>Стъпка 2: За да видите повече информация за конкретно почистване, кликнете върху него и то ще се отвори с цялата информация за него.</h4>
		<p>Тук може да видите цялата информация за почистването, като например: бележка за почистване от камериера, коментар от супервайзор и списък с всички задачи които са се изпълнявали по време на почистването, както и дали са задължителни или не.</p>
		<img src="/assets/images/help-center/cleaning-sessions-open-bg.png" style="border: 1px solid #ccc" />
	`,

	OVERVIEW_CONTENT: `
		<h4>Тук може да видите колко стаи са назначени, неназначени, в процес на почистване от вашият Екип общо за деня, както и общата продължителност на почистване на всеки един камериер.</h4>
		<img src="/assets/images/help-center/roomie-ai-performance-analysis-bg.png" style="border: 1px solid #ccc" />
	`,

	DAILY_ASSIGNMENTS_LIST_CONTENT: `
		<h4>Тук може да видите всички задачи по отделно за всеки камериер и техният прогрес.</h4>
		<img src="/assets/images/help-center/roomie-ai-daily-assignments-list-bg.png" style="border: 1px solid #ccc" />
	`,

	ROOMIE_AI_INTELLIGENT_ASSISTANT_CONTENT: `
		<h4>Roomie AI е интелигентен асистент, който ви помага да управлявате вашият Екип по-ефективно.</h4>
		<img src="/assets/images/help-center/roomie-ai-intelligent-assistant-bg.png" style="border: 1px solid #ccc" />
		<p>За да бъде ефективен в автоматичното разпределение на стаи към камериерите, интелигентният асистент RoomieAI изисква наличието на предварителни данни, които да анализира и използва.</p>
		<p>RoomieAI е самоубочаващ се Изкуствен Интелект, който се усъвършенства чрез ежедневните задачи и анализира индивидуалната производителност на всеки камериер. Това му позволява да разпределя задачите по възможно най-оптимален начин.</p>
		<p>Асистентът се активира автоматично, след като е събрал и обработил достатъчно информация от предходните дни, необходима за ефективен анализ и вземане на решения.</p>
		<p>След като RoomieAI се активира и събере достатъчно данни, той поема пълния контрол върху ежедневното разпределение на задачите с цел максимална ефективност.</p>
		<p>Системата взема предвид множество фактори, включително времето, необходимо на всеки камериер за почистване на различни типове стаи, общото време за изпълнение на дневните задължения, както и оценките и обратната връзка от Главните Камериери относно качеството на почистване.</p>
		<p>На базата на този анализ RoomieAI разпределя задачите индивидуално, като оптимизира натовареността и приоритизира висококачественото обслужване. Така се гарантира не само по-висока производителност, но и по-добро клиентско изживяване.</p>
	`,

	CLEANING_OPERATIONS_CONTENT: `
		<h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да използвате страницата "Почистване" (Главен Камериер и Администратор)</li>
            <li>Как се пуска техническа заявка за проблем (Главен Камериер и Администратор)</li>
        </ul>
		<h3>Как да използвате страницата "Почистване" (Главен Камериер и Администратор)</h3>
		<h4>Когато потребител с роля Главен Камериер или Администратор отвори страницата "Почистване", се визуализират всички стаи с техният статус и информация на кой е назначена за почистване, както и възможноста за задаване/отменяне на експресно почистване с едно кликване.</h4>
		<img src="/assets/images/help-center/cleaning-page-bg.png" style="border: 1px solid #ccc;" />
	`,

	CLEANING_PAGE_CLEANER_CONTENT: `
		<h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да започнете и приключите почистване на стая</li>
        </ul>
		<h3>Как да започна и приключите почистване</h3>
		<h4>На страница "Почистване", се визуализират всички стаи които са ви назначени за почистване и техният приоритет</h4>
		<img src="/assets/images/help-center/cleaner-page-mobile-bg.png" style="border: 1px solid #ccc;" />
		<h4>Стъпка 1: Кликнете върху бутона "Започни почистване"</h4>
		<p>Ще се появи прозорец с брояч в реално време и всички задачи които трябва да бъдат изпълнени.</p>
		<img src="/assets/images/help-center/cleaner-page-currently-cleaning-bg.png" style="border: 1px solid #ccc;" />
		<h4>Стъпка 2: Маркирате завършените задачи с кутийката която се намира в ляво на всяка задача</h4>
		<h4>Стъпка 3: Кликнете върху бутона "Завърши почистване"</h4>
		<p>Стаята ще бъде маркирана като почистена и ще се появи в секцията "Почистени стаи" на страницата "Почистване".</p>
	`,

	CLEANER_SUBMIT_PROBLEM_CONTENT: `
		<h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да докладвате за проблем в стая</li>
        </ul>
		<h4>На страница "Почистване", се визуализират всички стаи и във всяка една от тях има бутон с иконка на инструменти</h4>
		<img src="/assets/images/help-center/cleaner-page-mobile-bg.png" style="border: 1px solid #ccc;" />
		<h4>Стъпка 1: Кликнете върху бутона с иконката на инструменти</h4>
		<p>Ще се появи прозорец в който можете да изберете за какъв елемент се отнася проблема, приоритет на заявката и да опишете проблема с повече информация.</p>
		<img src="/assets/images/help-center/cleaner-page-tech-request-dialog-bg.png" style="border: 1px solid #ccc;" />
		<h4>Стъпка 2: След попълване на полетата натиснете бутона "Създай заявка"</h4>
		<p>Заявката ще бъде създадена и персонала който отговаря за техническата поддръжка ще бъде уведомен веднага.</p>
	`,

	TECHNICAL_SUPPORT_CONTENT: `
		<h3><b style="color: red;">Важно!</b> Само потребителите с роля Техническа поддръжка могат да обработват заявките за поддръжка.</h3>
		<h3>Какво Ще Научите</h3>
        <ul>
            <li>Как да обработвате заявките за поддръжка</li>
			<li>Как да прегледате пълната информация на конкретна поддръжка</li>
        </ul>
		<h3>Как да обработвате заявките за поддръжка</h3>
		<h4>На страницата "Техническа поддръжка" можете да видите всички заявки за поддръжка, които са изпратени от другите потребители.</h4>
		<img src="/assets/images/help-center/tech-support-bg.png" style="border: 1px solid #ccc" />
		<h4>Стъпка 1: Кликнете върху бутона "Започни" на заявката която искате да обработите</h4>
		<p>Заявката ще бъде маркирана като "В процес" и ще се брои към кутийката "В процес".</p>
		<img src="/assets/images/help-center/tech-support-open-bg.png" style="border: 1px solid #ccc" />
		<h4>Стъпка 2: След като сте обработили заявката, кликнете върху бутона "Завърши" на заявката</h4>
		<p>Заявката ще бъде маркирана като "Завършена" и ще се брои към кутийката "Завършени".</p>
		<img src="/assets/images/help-center/tech-support-closed-bg.png" style="border: 1px solid #ccc" />
		<hr style="border: 1px solid #ccc" />
		<h3>Как да прегледате пълната информация на конкретна поддръжка</h3>
		<h4>Натиснете бутона "Преглед" върху заявката на която искате да видите пълната информация.</h4>
		<p>Ще се отвори прозорец в който ще видите цялата информация</p>
		<img src="/assets/images/help-center/tech-support-view-bg.png" style="border: 1px solid #ccc" />
	`,
	
	// Related Links
	CREATING_YOUR_FIRST_ACCOUNT: 'Създаване на Първия Ви Акаунт',
	CREATING_YOUR_FIRST_ACCOUNT_DESC: 'Стъпка по стъпка ръководство за създаване на акаунт',
	DASHBOARD_NAVIGATION: 'Навигация в Таблото',
	DASHBOARD_NAVIGATION_DESC: 'Научете как да навигирате ефективно в таблото',
	PROFILE_SETUP_GUIDE: 'Настройване на Профил ',
	PROFILE_SETUP_GUIDE_DESC: 'Пълно ръководство за настройване на профила ви',
	ASSIGNMENTS_MANAGEMENT: 'Управление на Задачите ',
	ASSIGNMENTS_MANAGEMENT_SUBTITLE: 'Научете как да управлявате задачите на вашият Екип',
	CONTACT_SUPPORT: 'Свързване с Поддръжка',
	CONTACT_SUPPORT_DESC: 'Получете помощ от нашия екип за поддръжка',
	
	
	// Common UI
	BACK_TO_GUIDES_AND_RESOURCES: 'Връщане към Ръководство',
    BACK_TO_HELP_CENTER: 'Връщане към Помощен Център',
	RELATED_ARTICLES: 'Свързани Статии',
	WAS_THIS_PAGE_HELPFUL: 'Беше ли тази страница полезна?',
	LAST_UPDATED: 'Последно обновена на:',
	RECENTLY_UPDATED: 'Наскоро обновена',
	BY: 'От',
	MIN_READ: 'мин четене',
	FEATURED: 'Препоръчана',
	NEXT: 'Следваща',
	REMOVING_MEDIA: 'Премахване на медия от проект',
    PUBLISHED: 'Публикувано на:',
};

export default locale;
